import { BiEventType } from './constants';
// these are common for all events, you can omit them as they will be automatically mixed in
const commonFields = {
    requiredFields: [
        'evid',
        'client_id',
        'platform',
        'referer',
        'requestid',
        'url',
        'version'
    ],
    optionalFields: [
        'uuid',
        'view',
        'component',
        'notification_message_id'
    ]
};
/** @deprecated please use the new event interfaces instead */ const eventRegistry = {
    [BiEventType.SORT_TYPE_SELECT]: {
        requiredFields: [
            'menu_selection',
            'dropdown_type'
        ],
        optionalFields: [
            'sectionname'
        ]
    },
    [BiEventType.SEARCH_TAG_CLICK]: {
        requiredFields: [
            'tag_text',
            'is_selected'
        ],
        optionalFields: [
            'link_url'
        ]
    },
    [BiEventType.PROFILE_NAV_BAR]: {
        requiredFields: [
            'link_name',
            'itemid',
            'typeid'
        ],
        optionalFields: []
    },
    [BiEventType.COMMENT_ACTION]: {
        requiredFields: [
            'itemid',
            'typeid',
            'commentid',
            'commenterid'
        ],
        optionalFields: [
            'widgetname',
            'sectionname',
            'menu_item_name',
            'is_comment_thread'
        ]
    },
    [BiEventType.CLICK_VIEW_REPLY_TO_COMMENT]: {
        requiredFields: [
            'itemid',
            'typeid',
            'commentid',
            'commenterid'
        ],
        optionalFields: []
    },
    [BiEventType.CLICK_COMMENT_LIKE]: {
        requiredFields: [
            'is_liking',
            'itemid',
            'typeid',
            'commentid',
            'commenterid'
        ],
        optionalFields: [
            'is_comment_thread',
            'notification_type'
        ]
    },
    [BiEventType.SEND_NOTE_CLICK]: {
        requiredFields: [
            'recipientid',
            'sectionname'
        ],
        optionalFields: [
            'typeid',
            'itemid',
            'rank',
            'sectionid',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'sort_type',
            'reason_shown',
            'notification_type',
            'notification_sender_id'
        ]
    },
    [BiEventType.GIFT_CLICK]: {
        requiredFields: [
            'recipientid'
        ],
        optionalFields: []
    },
    [BiEventType.GIFT_SELECT_CLICK]: {
        requiredFields: [
            'recipientid',
            'menu_item_name'
        ],
        optionalFields: [
            'link_url'
        ]
    },
    [BiEventType.GALLERY_SEARCH_CLICK]: {
        requiredFields: [],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.PROFILE_SUB_NAV_BAR]: {
        requiredFields: [
            'menu_item'
        ],
        optionalFields: [
            'itemid',
            'typeid'
        ]
    },
    [BiEventType.PROFILE_ABOUT_SIDEBAR]: {
        requiredFields: [
            'menu_item_name'
        ],
        optionalFields: [
            'itemid',
            'typeid'
        ]
    },
    [BiEventType.PROFILE_STATS_SIDEBAR]: {
        requiredFields: [
            'menu_item_name'
        ],
        optionalFields: [
            'itemid',
            'typeid'
        ]
    },
    [BiEventType.PROFILE_SUB_NAV_BAR_TOGGLE]: {
        requiredFields: [
            'itemid',
            'typeid',
            'toggle_value'
        ],
        optionalFields: []
    },
    [BiEventType.PROFILE_LOAD_MORE_CLICK]: {
        requiredFields: [
            'widgetname',
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'sectionname'
        ]
    },
    [BiEventType.PROFILE_ORDER_COMMISSION]: {
        requiredFields: [
            'itemid',
            'typeid',
            'creatorid',
            'points'
        ],
        optionalFields: [
            'sectionname'
        ]
    },
    [BiEventType.DONATE_POINTS_CLICK]: {
        requiredFields: [
            'recipientid',
            'widgetname'
        ],
        optionalFields: []
    },
    [BiEventType.DONATION_POOL_SETUP_CONFIRM]: {
        requiredFields: [
            'view',
            'widgetname',
            'donation_goal_points',
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.PROFILE_GALLERY_VIEW_MODE_CLICK]: {
        requiredFields: [
            'view_mode'
        ],
        optionalFields: []
    },
    [BiEventType.NAVIGATION_ARROW_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'next_itemid',
            'direction'
        ],
        optionalFields: [
            'galleryid'
        ]
    },
    [BiEventType.THEATRE_MODE]: {
        requiredFields: [
            'deviationid',
            'viewmode'
        ],
        optionalFields: []
    },
    [BiEventType.FULLSCREEN_MODE]: {
        requiredFields: [
            'deviationid',
            'viewmode'
        ],
        optionalFields: []
    },
    [BiEventType.ZOOM_MODE]: {
        requiredFields: [
            'deviationid',
            'viewmode'
        ],
        optionalFields: []
    },
    [BiEventType.BACK_TO_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'link_url'
        ],
        optionalFields: [
            'next_itemid',
            'next_typeid'
        ]
    },
    [BiEventType.GIVE_BADGE_AWARD]: {
        requiredFields: [
            'sectionname',
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.CLICK_DOWNLOAD_BUTTON]: {
        requiredFields: [
            'deviationid',
            'ispaiddownload'
        ],
        optionalFields: []
    },
    [BiEventType.DOWNLOAD_NOW_CLICK]: {
        requiredFields: [
            'deviationid'
        ],
        optionalFields: []
    },
    [BiEventType.START_DOWNLOAD_CLICK]: {
        requiredFields: [
            'deviationid'
        ],
        optionalFields: []
    },
    [BiEventType.ADD_TO_COLLECTION_DONE_CLICK]: {
        requiredFields: [
            'view',
            'creatorid',
            'typeid',
            'itemid',
            'num_collections'
        ],
        optionalFields: [
            'sectionname',
            'collectionid'
        ]
    },
    [BiEventType.CLICK_COPY]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'deviationid'
        ]
    },
    [BiEventType.BUY_CLICK]: {
        requiredFields: [
            'deviationid'
        ],
        optionalFields: []
    },
    [BiEventType.GALLERY_PURCHASE]: {
        requiredFields: [
            'typeid',
            'itemid',
            'galleryid'
        ],
        optionalFields: [
            'points',
            'widgetname',
            'sectionid',
            'sectionname',
            'section_typeid',
            'authorid',
            'rank',
            'reason_shown',
            'sectionrank',
            'sectiontype',
            'sort_type'
        ]
    },
    [BiEventType.CHANGE_BACKGROUND_CLICK]: {
        requiredFields: [
            'typeid',
            'itemid',
            'background_id'
        ],
        optionalFields: []
    },
    [BiEventType.DEVIATION_EDIT_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: []
    },
    [BiEventType.DEVIATION_DELETE_CLICK]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.TAG_CLICK]: {
        requiredFields: [
            'tag_text',
            'link_url'
        ],
        optionalFields: [
            'tagid'
        ]
    },
    [BiEventType.SUBJECT_CLICK]: {
        requiredFields: [
            'view',
            'subject_name',
            'subject_type',
            'itemid',
            'typeid'
        ],
        optionalFields: []
    },
    [BiEventType.LOCATION_CLICK]: {
        requiredFields: [
            'location_name',
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SECTION_SELECT]: {
        requiredFields: [],
        optionalFields: [
            'sectionname',
            'is_from_navbar'
        ]
    },
    [BiEventType.CHANGE_FEED_MODE]: {
        requiredFields: [
            'feed_mode',
            'previous_feed_mode'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.NOTIFICATION_CLICK]: {
        requiredFields: [
            'link_url',
            'notification_type'
        ],
        optionalFields: [
            'notification_sender_id',
            'notification_rank',
            'notification_type_id',
            'notification_item_id'
        ]
    },
    [BiEventType.NOTIFICATION_GIVE_CLICK]: {
        requiredFields: [
            'notification_sender_id',
            'notification_type'
        ],
        optionalFields: []
    },
    [BiEventType.LIVE_NOTIFICATION_TOGGLE]: {
        requiredFields: [
            'is_selected'
        ],
        optionalFields: []
    },
    [BiEventType.LIVE_NOTIFICATION_CLICK]: {
        requiredFields: [
            'is_selected'
        ],
        optionalFields: []
    },
    [BiEventType.LIVE_NOTIFICATION_ACTIVITY_OPTION]: {
        requiredFields: [
            'is_selected',
            'notification_type'
        ],
        optionalFields: [
            'notification_type_id'
        ]
    },
    [BiEventType.WATCH_ITEM_REMOVE_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'rank'
        ],
        optionalFields: [
            'feed_mode',
            'is_grouped',
            'sectionname',
            'sectionid',
            'section_typeid',
            'items_selected_count',
            'notification_sender_id',
            'notification_type',
            'groupid',
            'button_name'
        ]
    },
    [BiEventType.NEW_CHAT]: {
        requiredFields: [],
        optionalFields: [
            'notification_sender_id',
            'notification_type',
            'notification_message_id'
        ]
    },
    [BiEventType.ENABLE_FLOATING_CHAT]: {
        requiredFields: [
            'toggle'
        ],
        optionalFields: []
    },
    [BiEventType.ONLINE_MODE]: {
        requiredFields: [
            'online_mode'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_MUTE_MODE]: {
        requiredFields: [
            'mute_mode'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_DROPDOWN_MENU]: {
        requiredFields: [
            'chat_uuid',
            'menu_item'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_SELECT]: {
        requiredFields: [
            'chat_uuid'
        ],
        optionalFields: [
            'chat_list_type'
        ]
    },
    [BiEventType.CHAT_MAX_MIN]: {
        requiredFields: [
            'chat_uuid',
            'is_expanding',
            'menu_item'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_ADD_MEDIA]: {
        requiredFields: [
            'chat_uuid'
        ],
        optionalFields: []
    },
    [BiEventType.ADD_MEDIA_TYPE]: {
        requiredFields: [
            'chat_uuid',
            'media_type'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_SEND]: {
        requiredFields: [
            'chat_uuid'
        ],
        optionalFields: []
    },
    [BiEventType.ADD_USER_TO_CHAT]: {
        requiredFields: [
            'chat_uuid'
        ],
        optionalFields: []
    },
    [BiEventType.ADD_TO_GROUP_BUTTON]: {
        requiredFields: [
            'chat_uuid',
            'num_users_added',
            'added_user_guids'
        ],
        optionalFields: []
    },
    [BiEventType.CHAT_ACTION_CONFIRM]: {
        requiredFields: [
            'chat_uuid',
            'view',
            'menu_item'
        ],
        optionalFields: []
    },
    [BiEventType.CLOSE_BANNER_AD]: {
        requiredFields: [
            'campaignid',
            'realestateid'
        ],
        optionalFields: []
    },
    [BiEventType.VIEW_MODE_SELECT]: {
        requiredFields: [
            'link_name'
        ],
        optionalFields: []
    },
    [BiEventType.VIEW_MORE_NOTIFICATIONS_CLICK]: {
        requiredFields: [
            'is_grouped',
            'feed_mode'
        ],
        optionalFields: [
            'sectionname',
            'groupid'
        ]
    },
    [BiEventType.NOTIFICATIONS_SECTION_SELECT]: {
        requiredFields: [
            'is_from_navbar',
            'feed_mode'
        ],
        optionalFields: [
            'sectionname',
            'groupid'
        ]
    },
    [BiEventType.ADD_NEW_CONTENT_CLICK]: {
        requiredFields: [
            'widgetname'
        ],
        optionalFields: []
    },
    [BiEventType.PROFILE_COVER_CLICK]: {
        requiredFields: [
            'is_update'
        ],
        optionalFields: []
    },
    [BiEventType.PROFILE_WATCH_INTRO]: {
        requiredFields: [
            'link_url'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.REDIRECT_TO_LOGIN]: {
        requiredFields: [
            'referral_info'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.SIGNUP_SCREEN_SHOW]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.LOGIN_ON_SIGNUP_CLICK]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.TERMS_CLICK]: {
        requiredFields: [
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.POLICY_CLICK]: {
        requiredFields: [
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.SIGNUP_ON_SIGNUP_CLICK]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.SIGNUP_SUCCESS]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.SIGNUP_ERROR]: {
        requiredFields: [
            'error_message'
        ],
        optionalFields: []
    },
    [BiEventType.WELCOME_SCREEN_SHOW]: {
        requiredFields: [
            'auth_mode',
            'absent_days',
            'is_new_user'
        ],
        optionalFields: []
    },
    [BiEventType.WELCOME_START_CLICK]: {
        requiredFields: [
            'auth_mode',
            'is_new_user'
        ],
        optionalFields: []
    },
    [BiEventType.WELCOME_CHANGE_EMAIL_CLICK]: {
        requiredFields: [
            'auth_mode',
            'is_new_user'
        ],
        optionalFields: []
    },
    [BiEventType.ALMOST_DONE_SHOW]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.ALMOST_DONE_CHANGE_ADDRESS_CLICK]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.ALMOST_DONE_RESEND_CLICK]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.ALMOST_DONE_CLOSE]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.LOGIN_SCREEN_SHOW]: {
        requiredFields: [
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_SCREEN_SIGNUP_CLICK]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.LOGIN_SCREEN_SUBMIT]: {
        requiredFields: [
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_REMEMBER_CLICK]: {
        requiredFields: [
            'new_state',
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_FORGOT_PASSWORD_CLICK]: {
        requiredFields: [
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_ERROR]: {
        requiredFields: [
            'error_message',
            'error_type',
            'user_name_challenge_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_SUCCESS]: {
        requiredFields: [
            'is_new_user',
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WELCOME_SCREEN_CLOSE]: {
        requiredFields: [
            'auth_mode',
            'is_new_user'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_SHOW]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_OPTION_TOGGLE]: {
        requiredFields: [
            'auth_mode',
            'new_state',
            'option'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_OTHER_DONE]: {
        requiredFields: [
            'auth_mode',
            'other_desc'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_OTHER_CANCEL]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_SKIP]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.INTENT_SUBMIT]: {
        requiredFields: [
            'auth_mode'
        ],
        optionalFields: []
    },
    [BiEventType.LOGIN_CAPTCHA_SHOW]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.CLICK_ON_COMMENTS_TO_START_TYPING]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'is_comment_thread',
            'notification_type'
        ]
    },
    [BiEventType.CLICK_REPLY_TO_COMMENT]: {
        requiredFields: [
            'itemid',
            'typeid',
            'commenterid',
            'commentid'
        ],
        optionalFields: [
            'is_comment_thread',
            'notification_type'
        ]
    },
    [BiEventType.LOAD_MORE_COMMENTS_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'is_comment_thread',
            'widgetname',
            'is_load_previous',
            'notification_type'
        ]
    },
    [BiEventType.COMMENT_BUTTON_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'is_reply'
        ],
        optionalFields: [
            'is_comment_thread',
            'notification_type'
        ]
    },
    [BiEventType.WATCH_SUGGESTION_REMOVE_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'feed_mode',
            'rank'
        ],
        optionalFields: [
            'attribution'
        ]
    },
    [BiEventType.WATCH_SUGGESTION_SELECT]: {
        requiredFields: [
            'is_selected',
            'friendid',
            'rank'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SUGGESTION_SELECT_CANCEL]: {
        requiredFields: [
            'friends'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SUGGESTION_WATCH]: {
        requiredFields: [
            'friends'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SUGGESTION_LOAD_MORE]: {
        requiredFields: [
            'offset'
        ],
        optionalFields: []
    },
    [BiEventType.POPUP_CLICK_ADD_TO_COLLECTION]: {
        requiredFields: [
            'itemid',
            'typeid',
            'creatorid',
            'sectionname'
        ],
        optionalFields: []
    },
    [BiEventType.MANAGE_WATCHLIST]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_FILTER_SEARCH_ICON_CLICK]: {
        requiredFields: [],
        optionalFields: [
            'typeid',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname'
        ]
    },
    [BiEventType.WATCH_FILTER_CLOSE_SEARCH_CLICK]: {
        requiredFields: [
            'typeid',
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_FILTER_SELECT_ALL_CLICK]: {
        requiredFields: [],
        optionalFields: [
            'select_all_type',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname'
        ]
    },
    [BiEventType.WATCH_FILTER_TAB_SELECTION]: {
        requiredFields: [
            'typeid',
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_FILTER_SEARCH]: {
        requiredFields: [
            'search_text',
            'typeid',
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.MORE_MENU_CLICK]: {
        requiredFields: [],
        optionalFields: [
            'itemid',
            'typeid',
            'sort_type',
            'reason_shown',
            'rank',
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
            'is_grouped'
        ]
    },
    [BiEventType.FEED_SORT_ORDER_SELECT]: {
        requiredFields: [
            'sort_order',
            'feed_mode',
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.COMMENT_CANCEL_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'is_comment_thread'
        ]
    },
    [BiEventType.COMMENT_DELETION_UNDO]: {
        requiredFields: [
            'commenterid',
            'commentid',
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'is_comment_thread'
        ]
    },
    [BiEventType.COMMENT_EDIT_CLICK]: {
        requiredFields: [
            'commentid',
            'itemid',
            'typeid'
        ],
        optionalFields: [
            'is_comment_thread'
        ]
    },
    [BiEventType.WATCH_POPUP_SELECT_ALL]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_POPUP_SELECT_NONE]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_GROUP_BY_ARTIST_CLICK]: {
        requiredFields: [
            'is_grouped',
            'sectionname',
            'feed_mode'
        ],
        optionalFields: [
            'groupid'
        ]
    },
    [BiEventType.WATCH_POPUP_UNDO_REMOVAL]: {
        requiredFields: [
            'undo_action'
        ],
        optionalFields: [
            'feed_mode',
            'items_selected_count',
            'is_grouped'
        ]
    },
    [BiEventType.WATCH_VIEW_ALL_BY_ARTIST]: {
        requiredFields: [
            'typeid',
            'itemid',
            'rank'
        ],
        optionalFields: [
            'feed_mode',
            'sectionname'
        ]
    },
    [BiEventType.WATCH_POPUP_SAVE]: {
        requiredFields: [
            'feed_mode',
            'items_selected_count'
        ],
        optionalFields: [
            'groupid'
        ]
    },
    [BiEventType.WATCH_POPUP_REMOVE]: {
        requiredFields: [
            'feed_mode',
            'items_selected_count'
        ],
        optionalFields: [
            'groupid'
        ]
    },
    [BiEventType.WATCH_POPUP_CLOSE]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: [
            'groupid'
        ]
    },
    [BiEventType.WATCH_DEVIATION_SELECT]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'typeid',
            'itemid',
            'rank',
            'groupid',
            'notification_type',
            'notification_sender_id',
            'items_selected_count'
        ]
    },
    [BiEventType.WATCH_DEVIATION_DESELECT]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'typeid',
            'itemid',
            'rank',
            'groupid',
            'notification_type',
            'notification_sender_id',
            'items_selected_count'
        ]
    },
    [BiEventType.WATCH_CONFIRM_REMOVAL]: {
        requiredFields: [
            'is_grouped',
            'removal_confirmed'
        ],
        optionalFields: [
            'typeid',
            'itemid',
            'groupid',
            'rank',
            'sectionname',
            'section_typeid',
            'sectionid',
            'notification_type',
            'items_selected_count',
            'notification_sender_id',
            'feed_mode'
        ]
    },
    [BiEventType.SELECT_BACKGROUND]: {
        requiredFields: [
            'typeid',
            'itemid',
            'background_id'
        ],
        optionalFields: []
    },
    [BiEventType.CLOSE_BACKGROUND_SELECTION_MODAL]: {
        requiredFields: [
            'typeid',
            'itemid',
            'background_id'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_MENU_ITEM_SELECTION]: {
        requiredFields: [
            'typeid',
            'itemid',
            'rank',
            'sectionname',
            'menu_item'
        ],
        optionalFields: [
            'sort_type',
            'feed_mode',
            'is_grouped'
        ]
    },
    [BiEventType.USER_OR_GROUP_FEED_SELECT]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'feed_mode',
            'sectionid',
            'section_typeid',
            'sectionname',
            'indicator',
            'is_birthday'
        ]
    },
    [BiEventType.BUY_CORE_BUTTON]: {
        requiredFields: [
            'referral_info'
        ],
        optionalFields: [
            'itemid',
            'typeid',
            'background_id'
        ]
    },
    [BiEventType.DELETE_DEVIATION_CONFIRM_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid'
        ],
        optionalFields: []
    },
    [BiEventType.BUY_CORE_BUTTON_CLICK]: {
        requiredFields: [
            'give_core_or_become_core',
            'membershiplength',
            'membershiptypeid'
        ],
        optionalFields: []
    },
    [BiEventType.PACKAGE_PICKER_CLICK]: {
        requiredFields: [
            'button_type',
            'core_type',
            'give_core_or_become_core'
        ],
        optionalFields: []
    },
    [BiEventType.USER_SYMBOL_CLICK]: {
        requiredFields: [
            'itemid',
            'typeid',
            'symbol'
        ],
        optionalFields: [
            'attribution',
            'rank',
            'sectionname',
            'sectionid',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'sort_type',
            'reason_shown'
        ]
    },
    [BiEventType.USERS_SYMBOL_LEARN_MORE_CLICK]: {
        requiredFields: [
            'link_name',
            'link_url'
        ],
        optionalFields: [
            'rank'
        ]
    },
    [BiEventType.STATS_CHANGE_LEVEL_CLICK]: {
        requiredFields: [
            'time_period',
            'typeid',
            'itemid',
            'is_viewing_same_option'
        ],
        optionalFields: []
    },
    [BiEventType.STATS_OVERVIEW_TAB_CLICK]: {
        requiredFields: [
            'typeid',
            'creatorid',
            'stat_name',
            'rank',
            'sectionname',
            'time_period',
            'is_viewing_same_option'
        ],
        optionalFields: []
    },
    [BiEventType.STATS_TABLE_SORT_CLICK]: {
        requiredFields: [
            'typeid',
            'creatorid',
            'stat_name',
            'rank',
            'sectionname',
            'time_period',
            'is_viewing_same_option'
        ],
        optionalFields: []
    },
    [BiEventType.ELNINO_VIEW]: {
        requiredFields: [
            'typeid',
            'itemid',
            'rank'
        ],
        optionalFields: []
    },
    [BiEventType.COMMISSION_ORDER_ACCEPTED]: {
        requiredFields: [
            'commissionid',
            'commission_buyerid',
            'feed_mode',
            'points'
        ],
        optionalFields: []
    },
    [BiEventType.COMMISSION_ORDER_DECLINED]: {
        requiredFields: [
            'commissionid',
            'commission_buyerid',
            'feed_mode',
            'points'
        ],
        optionalFields: []
    },
    [BiEventType.GROUP_INVITE_ACCEPTED]: {
        requiredFields: [
            'notification_sender_id',
            'groupid',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.GROUP_INVITE_DECLINED]: {
        requiredFields: [
            'notification_sender_id',
            'groupid',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.DEVIATION_TO_GROUP_ACCEPTED]: {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'groupid',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.DEVIATION_TO_GROUP_DECLINED]: {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'groupid',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.TAG_MODEL_REQUEST_CONFIRMED]: {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.TAG_MODEL_REQUEST_DENIED]: {
        requiredFields: [
            'deviationid',
            'notification_sender_id',
            'feed_mode'
        ],
        optionalFields: [
            'notification_type'
        ]
    },
    [BiEventType.NOTIFICATIONS_ITEM_SAVE]: {
        requiredFields: [
            'feed_mode',
            'is_grouped',
            'sectionname',
            'items_selected_count',
            'notification_sender_id',
            'notification_type',
            'items_selected_count'
        ],
        optionalFields: [
            'groupid'
        ]
    },
    [BiEventType.EXPAND_NOTIFICATIONS]: {
        requiredFields: [
            'feed_mode'
        ],
        optionalFields: [
            'groupid',
            'is_grouped',
            'sectionname'
        ]
    },
    [BiEventType.TOPICS_ONBOARDING_SHOW]: {
        requiredFields: [],
        optionalFields: []
    },
    [BiEventType.TOPICS_ONBOARDING_SELECT]: {
        requiredFields: [
            'typeid',
            'itemid',
            'topic',
            'is_selected',
            'rank',
            'deviationid'
        ],
        optionalFields: []
    },
    [BiEventType.TOPICS_ONBOARDING_DONE]: {
        requiredFields: [
            'num_topics_selected'
        ],
        optionalFields: []
    },
    [BiEventType.SELECT_CHAT_LIST]: {
        requiredFields: [
            'chat_list_type'
        ],
        optionalFields: []
    },
    [BiEventType.CLICK_JOIN]: {
        requiredFields: [],
        optionalFields: [
            'referral_info'
        ]
    },
    [BiEventType.CLICK_LOGIN]: {
        requiredFields: [],
        optionalFields: [
            'referral_info'
        ]
    },
    [BiEventType.CHAT_STATUS]: {
        requiredFields: [
            'connection_status'
        ],
        optionalFields: []
    },
    [BiEventType.READ_MORE_CLICK]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'creatorid',
            'rank',
            'sort_type'
        ]
    },
    [BiEventType.BADGE_AWARD_CLICK]: {
        requiredFields: [
            'badge_type',
            'badge_typeid'
        ],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.BADGE_HELP_CLICK]: {
        requiredFields: [],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.BADGE_TYPE_SELECT]: {
        requiredFields: [
            'badge_typeid',
            'badge_type'
        ],
        optionalFields: [
            'sectiontype',
            'sectionname',
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.SEND_CHAT_BUTTON_CLICK]: {
        requiredFields: [
            'friendid'
        ],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid',
            'sectionid',
            'section_typeid'
        ]
    },
    [BiEventType.DRAG_DEVIATION_TO_CHAT]: {
        requiredFields: [
            'deviationid'
        ],
        optionalFields: [
            'sectionname',
            'typeid',
            'itemid',
            'creatorid',
            'chat_uuid'
        ]
    },
    [BiEventType.NETWORK_BAR_NAV_CLICK]: {
        requiredFields: [
            'sectionname',
            'indicator'
        ],
        optionalFields: [
            'itemid',
            'typeid',
            'rank',
            'is_expanded'
        ]
    },
    [BiEventType.NETWORK_BAR_MENU_ICON]: {
        requiredFields: [
            'is_expanding',
            'indicator'
        ],
        optionalFields: []
    },
    [BiEventType.NETWORK_BAR_3DOTS_OPEN]: {
        requiredFields: [
            'sectionname',
            'indicator'
        ],
        optionalFields: [
            'itemid',
            'typeid',
            'rank'
        ]
    },
    [BiEventType.NETWORK_BAR_3DOTS_SELECT]: {
        requiredFields: [
            'sectionname',
            'indicator',
            'menu_item'
        ],
        optionalFields: [
            'itemid',
            'typeid',
            'rank'
        ]
    },
    [BiEventType.NETWORK_BAR_SECTION_EXPAND_COLLAPSE]: {
        requiredFields: [
            'sectionname',
            'indicator',
            'is_expanding',
            'is_expanded'
        ],
        optionalFields: []
    },
    [BiEventType.VIEW_GROUP_NOTIFICATION]: {
        requiredFields: [
            'sectionname',
            'itemid',
            'typeid',
            'groupid'
        ],
        optionalFields: []
    },
    [BiEventType.MORE_ACTIONS_GROUP_NOTIFICATION]: {
        requiredFields: [
            'notification_type',
            'items_selected_count',
            'menu_item'
        ],
        optionalFields: [
            'sectionname',
            'is_grouped',
            'groupid',
            'notification_sender_id',
            'feed_mode'
        ]
    },
    [BiEventType.JOIN_GROUP]: {
        requiredFields: [
            'groupid'
        ],
        optionalFields: [
            'sectionname'
        ]
    },
    [BiEventType.PROFILE_POST_FEED_DROPDOWN]: {
        requiredFields: [
            'menu_item'
        ],
        optionalFields: []
    },
    [BiEventType.CREDIT_CARD_TOKENIZATION]: {
        requiredFields: [
            'response_has_billing_token',
            'tokenization_http_response_code'
        ],
        optionalFields: []
    },
    [BiEventType.GET_MORE_POINTS]: {
        requiredFields: [
            'widgetname'
        ],
        optionalFields: []
    },
    [BiEventType.GIVE_POINTS_CLICK]: {
        requiredFields: [
            'points_total',
            'sent_personal_message',
            'widgetname'
        ],
        optionalFields: []
    },
    [BiEventType.BEGIN_TAKEDOWN_PROCESS]: {
        requiredFields: [
            'feed_mode',
            'sectionname',
            'deviationid'
        ],
        optionalFields: [
            'notification_sender_id',
            'notification_item_id',
            'link_name',
            'link_url',
            'notification_type'
        ]
    },
    [BiEventType.BUY_IN_POPUP_STORE]: {
        requiredFields: [
            'deviationid'
        ],
        optionalFields: []
    },
    [BiEventType.PAYMENT_BUTTON_CLICK]: {
        requiredFields: [
            'payment_type',
            'item_total',
            'num_items',
            'give_core_or_become_core',
            'subproductid',
            'is_form_valid'
        ],
        optionalFields: []
    },
    [BiEventType.PAYMENT_TYPE_CLICK]: {
        requiredFields: [
            'payment_type',
            'item_total',
            'num_items'
        ],
        optionalFields: []
    },
    [BiEventType.CANCEL_SUBSCRIPTION_CLICK]: {
        requiredFields: [
            'orderid'
        ],
        optionalFields: []
    },
    [BiEventType.CANCEL_SUBSCRIPTION_CONFIRM]: {
        requiredFields: [
            'orderid'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_ADD_NEW]: {
        requiredFields: [
            'is_empty_state_view'
        ],
        optionalFields: [
            'is_tip_jar',
            'widgetname'
        ]
    },
    [BiEventType.TIER_UPLOAD_COVER_IMAGE]: {
        requiredFields: [],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.TIER_PREVIEW_CLICK]: {
        requiredFields: [
            'preview_type'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.TIER_PUBLISH]: {
        requiredFields: [
            'display_subscribers',
            'access_settings'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.TIER_UPDATE]: {
        requiredFields: [
            'typeid',
            'itemid',
            'display_subscribers',
            'access_settings'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_SAVE_AS_DRAFT]: {
        requiredFields: [
            'display_subscribers',
            'access_settings'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.TIER_SAVE_AS_DRAFT_CONFIRM]: {
        requiredFields: [
            'display_subscribers',
            'access_settings'
        ],
        optionalFields: [
            'typeid',
            'itemid'
        ]
    },
    [BiEventType.TIER_DELETE]: {
        requiredFields: [
            'typeid',
            'itemid',
            'has_subscribers'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_DELETE_CONFIRM]: {
        requiredFields: [
            'typeid',
            'itemid',
            'has_subscribers'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_NAVIGATION_SELECT]: {
        requiredFields: [
            'typeid',
            'itemid',
            'authorid'
        ],
        optionalFields: []
    },
    [BiEventType.NOTIFICATIONS_OPT_OUT]: {
        requiredFields: [
            'notification_type',
            'deviationid'
        ],
        optionalFields: [
            'sectionname',
            'typeid'
        ]
    },
    [BiEventType.TIER_EDIT_CLICK]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'widgetname'
        ]
    },
    [BiEventType.TIER_VIEW_BUTTON]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: []
    },
    [BiEventType.VIEW_TIER_UNIQUE]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'referral_info',
            'sectionid',
            'sectionname',
            'section_typeid',
            'sectiontype',
            'sectionrank',
            'rank'
        ]
    },
    [BiEventType.VIEW_ADOPTABLES_TAB]: {
        requiredFields: [
            'typeid',
            'itemid',
            'referral_info'
        ],
        optionalFields: []
    },
    [BiEventType.VIEW_SUBSCRIPTION_TAB]: {
        requiredFields: [
            'typeid',
            'itemid',
            'referral_info'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SUB_FILTER_OPEN]: {
        requiredFields: [
            'filter_name'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_SUBSCRIBE]: {
        requiredFields: [
            'typeid',
            'itemid',
            'referral_info'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_UNSUBSCRIBE_CONFIRM]: {
        requiredFields: [
            'typeid',
            'itemid',
            'referral_info'
        ],
        optionalFields: []
    },
    [BiEventType.TIER_UPGRADE]: {
        requiredFields: [
            'typeid',
            'itemid'
        ],
        optionalFields: [
            'upgrade_type'
        ]
    },
    [BiEventType.TIER_UNSUBSCRIBE]: {
        requiredFields: [
            'typeid',
            'itemid',
            'referral_info'
        ],
        optionalFields: []
    },
    [BiEventType.WATCH_SUB_FILTER_SELECT]: {
        requiredFields: [
            'filter_name'
        ],
        optionalFields: []
    }
};
export default function getFieldsForEvent(evid) {
    const registry = eventRegistry[evid];
    if (!registry) {
        return;
    }
    return {
        optionalFields: [
            ...registry.optionalFields || [],
            ...commonFields.optionalFields
        ],
        requiredFields: [
            ...registry.requiredFields || [],
            ...commonFields.requiredFields
        ]
    };
}
